<script>
import MenuLinkSection from '../menu-link-section/MenuLinkSection.vue'
import TwitterIcon from '../twitter-icon/TwitterIcon.vue'
import FacebookIcon from '../facebook-icon/FacebookIcon.vue'
import InstagramIcon from '../instagram-icon/InstagramIcon.vue'
import AppStoreBadgesItem from '../app-store-badges-item/AppStoreBadgesItem.vue'
import ImageListItem from '../image-list-item/ImageListItem.vue'

export default {
  name: 'FooterLayout',
  components: {
    MenuLinkSection,
    TwitterIcon,
    FacebookIcon,
    InstagramIcon,
    AppStoreBadgesItem,
    ImageListItem
  },
  props: {
    linkSections: {
      type: Array,
      required: true
    }
  },
  methods: {
    isLastSection(index) {
      return index === this.linkSections.length - 1
    }
  }
}
</script>

<template lang="pug">
.footer-layout.flex-container
  .footer-layout__wrapper
    .grid-container
      .grid-x.grid-margin-x.footer-layout__top
        .footer-layout__column(v-for='(linkSection, index) in linkSections')
          menu-link-section(
            :links='linkSection.links'
            :heading='linkSection.heading'
            :isFooter='true'
          )
          .flex-container.sp__top--xs.sp__bottom--xs.social-media-links(
            v-if='isLastSection(index)'
          )
            a.social-media-links--twitter(
              href='https://twitter.com/thrivahealth'
              aria-label='twitter'
            )
              twitter-icon
            a.social-media-links--facebook(
              href='https://fb.com/thriva'
              aria-label='facebook'
            )
              facebook-icon
            a.social-media-links--instagram(
              href='https://instagram.com/thrivahealth'
              aria-label='instagram'
            )
              instagram-icon
          .section-splitter.divider(v-if='!isLastSection(index)')
        .flex-container.sp__bottom--xs.app-links
          p.grid-margin-x.text--white.fw--xx-heavy.app-links__title Get the app
          .grid-margin-x.app-links__icons
            app-store-badges-item.sp__top--xs(linkLocation='footer')
    .footer-layout__sub-content.grid-container.sp__bottom--sm
      .divider
      .footer-layout__accreditation(
        @click='$emit("onAccreditationClick")'
        :class='{ "footer-layout__accreditation--clickable": $listeners.onAccreditationClick }'
      )
        p.text--white.fw--xx-heavy Accreditation
        image-list-item.sp__top--xs.sp__bottom--xs(
          type='accreditation'
          :white='true'
          :gap='30'
          :height='40'
          :images='["iso-27001", "ce", "bsi", "bsiukas", "cqc"]'
        )
        p.text--white.fw--regular All our partner labs hold UKAS, ISO17025 / ISO15189 accreditations.
        p.footer-layout__certification-text.text--white.fw--regular Thriva has achieved ISO13485 certification by notified body BSI in September 2022.
      .divider
      .footer-layout__payment
        p.text--white.fw--xx-heavy Secure payment
        image-list-item.sp__top--xs(type='payment')
    .divider.full-width
    .footer-layout__bottom.flex-container
      img.footer-layout__icon(
        alt=''
        src='../../assets/images/icons/thriva-heart-whiteout.svg'
      )
      .footer-layout__copyright.text--white Copyright © Thriva Ltd {{ new Date().getFullYear() }}
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'
  .footer-layout
    justify-content: center
    align-items: center
    width: 100%
    min-height: 420px
    background-color: THRIVA.colours.carbon
    padding: 30px 20px 0 20px

    &__wrapper
      flex-direction: column
      justify-content: center

    &__column
      color: THRIVA.colours.white
      +media-breakpoint-up(lg)
        min-width: 180px
      +media-breakpoint-up(md)
        min-height: 300px

    &__top
      display: flex

    &__bottom
      justify-content: space-between
      padding: 20px 30px

    &__icon
      max-width: 28px

    &__sub-content
      display: grid
      gap: 20px

      +media-breakpoint-up(md)
        grid-template-columns: 1fr max-content
        padding: 0px

        .divider
          display: none

    &__copyright
      font-size: 14px

    &__accreditation

      &--clickable
        cursor: pointer

    &__certification-text

      +media-breakpoint-up(lg)
        white-space: nowrap

  .social-media-links
    width: 90px
    justify-content: space-between
    align-items: baseline

    &--twitter
    &--facebook
    &--instagram
      fill: THRIVA.colours.white
      &:hover
      &:active
      &:focus
        background-color: THRIVA.colours.carbon
        fill: THRIVA.colours.lagoon
        cursor: pointer

  .section-splitter
    width: 85vw

    +media-breakpoint-up(md)
      width: unset
      border-top: none

  .app-links
    border-top: 0.0625rem solid THRIVA.colours.cloud
    padding-top: 5px
    flex-direction: column
    align-items: initial
    +media-breakpoint-up(md)
      border-top: unset
      justify-content: start
      margin-right: 10px

    &__title
      padding: 5px
      +media-breakpoint-up(md)
        padding: 0px

    &__icons
      width: 85vw
      +media-breakpoint-up(lg)
        width: 180px
</style>
